import { SITE } from '../components/SEO';

const COURSES = [
  { name: 'Basic Computer Course', desc: 'Fundamentals of computer, typing, file management and internet basics.' },
  { name: 'Typing Classes', desc: 'English typing practice with speed and accuracy goals.' },
  { name: 'MS Office Course', desc: 'MS Word, Excel, PowerPoint and Outlook with real-world assignments.' },
  { name: 'Tally Course with GST', desc: 'Complete Tally accounting with GST configuration and reporting.' },
  { name: 'Python Course', desc: 'Python programming fundamentals with hands-on projects.' },
  { name: 'Web Development Course', desc: 'HTML, CSS, JavaScript and modern web basics.' },
  { name: 'Photoshop Course', desc: 'Photo editing, retouching and graphic design with Adobe Photoshop.' },
  { name: 'CorelDRAW Course', desc: 'Vector design, layouts, banners and printing with CorelDRAW.' },
  { name: 'Computer Hardware Course', desc: 'Computer assembly, troubleshooting and hardware maintenance.' },
  { name: 'C & C++ Programming', desc: 'Programming fundamentals with C and C++.' },
  { name: 'AI Tools Course', desc: 'Practical use of ChatGPT, Gemini and other AI tools.' },
];

export function buildCourseListSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    itemListElement: COURSES.map(function (c, i) {
      return {
        '@type': 'ListItem',
        position: i + 1,
        item: {
          '@type': 'Course',
          name: c.name,
          description: c.desc,
          provider: {
            '@type': 'EducationalOrganization',
            name: 'Genius Academy',
            sameAs: SITE.url,
          },
        },
      };
    }),
  };
}
